import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class DropboxService {

	headerStatus = '';

	constructor(
		private http: HttpClient
	) { }

	cancelRequest(signatureRequestId: string, username: string, companyId: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('username', username);
		params = params.set('companyId', companyId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/cancel`;

		return this.http.post(requestUrl, '', { headers, params });
	}

	// Checks to ensure a Dropbox Sign Embedded Requesting URL hasn't been used more than once.
	checkEmbeddedUrl(companyId: number, url: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('url', url);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/check-embedded-url`;

		return this.http.get<boolean>(requestUrl, { headers, params });
	}

	// createDropboxTeam(companyName: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyName', companyName);
	// 	//params = params.set('emailAddress', emailAddress);

	// 	const requestUrl = `${environment.serviceUrl}/dropbox-sign/team`;

	// 	return this.http.post<boolean>(requestUrl, '', { headers, params });
	// }

	// createDropboxSignSharedAccount(emailAddress: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('emailAddress', emailAddress);

	// 	const requestUrl = `${environment.serviceUrl}/dropbox-sign/account`;

	// 	return this.http.post<boolean>(requestUrl, '', { headers, params });
	// }

	assignUserToSharedTeam(emailAddress: string, companyId: number, accountType: string, isTrial: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('emailAddress', emailAddress);
		params = params.set('companyId', companyId);
		params = params.set('accountType', accountType);
		params = params.set('isTrial', isTrial);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/shared/team`;

		return this.http.put<boolean>(requestUrl, '', { headers, params });
	}

	createDropboxUserAuth(code: string, state: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('code', code);
		params = params.set('state', state);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/user`;

		return this.http.post(requestUrl, '', { headers, params, responseType: 'text' });
	}

	// Validates the params, ensures the license is valid, then generates a Dropbox Sign embedded requesting URL.
	// createEmbeddedUnclaimedDraft(file: File, signatureInfo: any, isSandbox: boolean, username: string, procoreUserId: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('username', username);
	// 	params = params.set('procoreUserId', procoreUserId);

	// 	const formData = new FormData();
	// 	if (file) {
	// 		formData.append('file', file, file.name);
	// 	}
	// 	formData.append('body', JSON.stringify(signatureInfo));

	// 	const requestUrl = `${environment.serviceUrl}/dropbox-sign/create-embedded-unclaimed-draft`;

	// 	return this.http.post(requestUrl, formData, { params, responseType: 'text' });
	// }

	createEmbeddedRequest(file: File, signatureInfo: any, isSandbox: boolean, username: string, procoreUserId: string, fileGenerationUuid: string) {
		let params = new HttpParams();
		params = params.set('isSandbox', isSandbox);
		params = params.set('fileGenerationUuid', fileGenerationUuid);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const formData = new FormData();
		if (file) {
			formData.append('file', file, file.name);
		}
		formData.append('body', JSON.stringify(signatureInfo));

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/embedded-request`;

		return this.http.post(requestUrl, formData, { params, responseType: 'text', observe: 'response' });
	}

	// finishEmbeddedUnclaimedDraft(file: File, signatureInfo: any, isSandbox: boolean, username: string, procoreUserId: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('username', username);
	// 	params = params.set('procoreUserId', procoreUserId);

	// 	const formData = new FormData();
	// 	if (file) {
	// 		formData.append('file', file, file.name);
	// 	}
	// 	formData.append('body', JSON.stringify(signatureInfo));

	// 	const requestUrl = `${environment.serviceUrl}/dropbox-sign/start-embedded-unclaimed-draft`;

	// 	return this.http.post(requestUrl, formData, { params, responseType: 'text' });
	// }

	getAuthUrl(username: string, companyId: number) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('companyId', companyId);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/auth-url`;

		return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	}

	// This checks it the user exists by username and company id, then returns the signature counts if it does. 
	// If not, it returns a null response.
	getDoesUserExistWithSignatureCounts(username: string, companyId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('companyId', companyId);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/user/exists`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getTemplates(companyId: number, userEmail: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('userEmail', userEmail);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/templates`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	getReminders(companyId: number, signatureRequestId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('signatureRequestId', signatureRequestId);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/reminders`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	sendReminder(companyId: number, signatureRequestId: string, signerEmail: string, userEmail: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('signerEmail', signerEmail);
		params = params.set('userEmail', userEmail);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/send-reminder`;

		return this.http.post<any>(requestUrl, '', { headers, params });
	}

	getSignatureDownloadStream(companyId: number, signatureRequestId: string, filename: string, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/pdf');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('filename', filename);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/dropbox-sign/download/stream`;

		return this.http.get(requestUrl, { headers, params, responseType: 'blob' });
	}
}
